import "./DeleteSectionModal.css";

import { overlay } from "overlay-kit";
import { FC, useState } from "react";

import { SectionType } from "components/server-types";
import { t } from "i18n/i18n";
import { ConfirmationDialog } from "mds/components/ConfirmationDialog";
import { LegacyTextField } from "mds/components/LegacyTextField";
import { useAppSelector } from "store";
import { selectCourseCodeBySectionId } from "store/selectors/section";

export const showUnlinkConfirmationModal = ({
  section,
  templateTitle,
}: {
  section: SectionType;
  templateTitle: string;
}) =>
  overlay.openAsync<boolean>(({ isOpen, close }) => (
    <UnlinkSectionModal
      open={isOpen}
      sectionId={section.id}
      sectionTitle={section.title}
      templateTitle={templateTitle}
      onClose={close}
      onConfirm={() => {}}
    />
  ));

type UnlinkSectionModalProps = {
  sectionId: string;
  sectionTitle: string;
  templateTitle: string;
  open: boolean;
  onConfirm: () => void;
  onClose: (confirmed: boolean) => void;
};

// eslint-disable-next-line react-refresh/only-export-components
const UnlinkSectionModal: FC<UnlinkSectionModalProps> = ({
  sectionId,
  sectionTitle,
  templateTitle,
  open,
  onConfirm,
  onClose,
}) => {
  const unlinkSectionTitle = t("sidebar_options_menu.unlink_confirm_button");
  const [disableUnlink, setDisableUnlink] = useState<boolean>(true);

  const courseCode = useAppSelector((state) => selectCourseCodeBySectionId(state, sectionId));
  const handleCourseConfirmationCheck = (text: string) => {
    setDisableUnlink(text !== courseCode);
  };

  return (
    <ConfirmationDialog
      confirmButtonDisabled={disableUnlink}
      confirmButtonKind="caution"
      confirmButtonText={unlinkSectionTitle}
      description={t("sidebar_options_menu.unlink_confirm_label", { name: sectionTitle })}
      open={open}
      title={unlinkSectionTitle}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <div className="section-delete-modal mt-8 flex flex-col items-start gap-8">
        <div className="section-delete-warning">
          {t("sidebar_options_menu.unlink_confirm_description", { template: templateTitle })}
        </div>

        <div className="flex flex-col gap-2">
          <label htmlFor="course-code">{t("section_list_panel.course_confirm_label")}</label>

          <LegacyTextField
            id="course-code"
            placeholder={t("section_list_panel.course_placeholder")}
            isEditing
            onChange={(event) => handleCourseConfirmationCheck(event.target.value)}
          />
        </div>
      </div>
    </ConfirmationDialog>
  );
};
